import React from 'react'
import { useParams } from 'react-router-dom'
import ResourceAllocationForm from './ResourceAllocationForm'

const ResourceAllocationEdit = () => {
  const { id } = useParams()
  
  return <ResourceAllocationForm mode="edit" allocationId={id} />
}

export default ResourceAllocationEdit

